import type { Options } from '@/models/option';
import { COUNTRIES } from '@/wabunka-src/constants/countries';

export const useCountry = (): Options => {
  return COUNTRIES.map((country: string) => {
    return {
      value: country,
      label: country,
    };
  });
};
